import { render } from "./modalAdquirir.vue?vue&type=template&id=ace87eb4"
import script from "./modalAdquirir.vue?vue&type=script&lang=js"
export * from "./modalAdquirir.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__